let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jw6Fw")).then(() => parcelRequire('6BnaY'));